module.exports = __webpack_public_path__ + "static/media/Design_Sprints.db991ee4.jpg";